import { ErrorMessage, type FieldValuesFromFieldErrors } from "@hookform/error-message";
import { guardString } from "@msuite/utils/strings";
import type { FieldErrors, FieldName, FieldValues, Path } from "react-hook-form";
import { FormErrorMessage } from "./form-error-message";

/** Props Interface */
export interface FormErrorProps<T extends FieldValues> {
	errors: FieldErrors<T>;
	name?: FieldName<FieldValuesFromFieldErrors<FieldErrors<T>>> | Path<T>;
	customMessage?: string;
	errorVariant?: "inline" | "tooltip";
}

export function FormError<T extends FieldValues>({
	errors,
	name,
	customMessage,
	errorVariant,
}: FormErrorProps<T>) {
	/** Guard */
	if (!errors) return null;
	if (!name) return null;

	/** Render */
	return (
		<ErrorMessage
			errors={errors}
			name={name as unknown as FieldName<FieldValuesFromFieldErrors<FieldErrors<T>>>}
			render={({ message }) =>
				errorVariant === "tooltip" ? (
					<FormErrorMessage
						name={name}
						message={customMessage || guardString(message)}
					/>
				) : (
					<p className="text-xs text-red-500!">{message}</p>
				)
			}
		/>
	);
}
